import {connect} from 'react-redux'
import ReportPanel from '../components/report-page/report-panel'
import * as reportActions from '../store/report/actions'
import * as decisionTreeActions from '../store/decision-tree/actions'
import * as monitoringActions from '../store/monitoring/actions'

export default connect((state) => {
  return {
    report: state.report,
    decisionTree: state.decisionTree,
    monitoring: state.monitoring,
    selectedTab: state.app.type,
  }
}, {...reportActions, ...decisionTreeActions, ...monitoringActions})(ReportPanel)



// WEBPACK FOOTER //
// ./src/containers/report-panel-container.js